module.exports = "/assets/site/images/bally_attila.jpg?f1a66a7ff0911e0a651d6c713b627dcb";